import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrepayBudgetMutationVariables = Types.Exact<{
  paymentMethodId: Types.Scalars['Int']['input'];
}>;


export type PrepayBudgetMutationPage = { readonly __typename?: 'RootMutationType', readonly prepayBudget: { readonly __typename?: 'YalperChargeResult', readonly confirmationUrl?: string | null } };


export const PrepayBudgetDocument = gql`
    mutation PrepayBudget($paymentMethodId: Int!) {
  prepayBudget(paymentMethodId: $paymentMethodId) {
    confirmationUrl
  }
}
    `;
export type PrepayBudgetMutationFn = Apollo.MutationFunction<PrepayBudgetMutationPage, PrepayBudgetMutationVariables>;

/**
 * __usePrepayBudgetMutation__
 *
 * To run a mutation, you first call `usePrepayBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepayBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepayBudgetMutation, { data, loading, error }] = usePrepayBudgetMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePrepayBudgetMutation(baseOptions?: Apollo.MutationHookOptions<PrepayBudgetMutationPage, PrepayBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepayBudgetMutationPage, PrepayBudgetMutationVariables>(PrepayBudgetDocument, options);
      }
export type PrepayBudgetMutationHookResult = ReturnType<typeof usePrepayBudgetMutation>;
export type PrepayBudgetMutationResult = Apollo.MutationResult<PrepayBudgetMutationPage>;
export type PrepayBudgetMutationOptions = Apollo.BaseMutationOptions<PrepayBudgetMutationPage, PrepayBudgetMutationVariables>;